// @ts-nocheck
import React, { useCallback, useMemo } from 'react';
import { Grid, Typography, Button, Box, Stack } from '@mui/material';
import { useNavigate, useRouteError } from 'react-router-dom';

import { ReactComponent as NimbusLogo } from '../../assets/Icons/MRMVaultColored.svg';
import { HAS_REFRESHED_KEY } from '../../const/CommonConst';

const ErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const showChunkLoadError = useMemo(() => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem(HAS_REFRESHED_KEY) || 'false'
    );
    return error?.message?.includes('ChunkLoadError') && !hasRefreshed;
  }, [error]);

  const unselectableStyles = {
    userSelect: 'none',
    WebkitTouchCallout: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
  };
  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  const handleGoToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const getErrorTitle = () => {
    if (showChunkLoadError) {
      return 'New version detected';
    }
    return 'Something went wrong';
  };

  const getErrorMessage = () => {
    if (showChunkLoadError) {
      return 'Refreshing the page in 3 seconds...';
    }
    return 'Please reload';
  };

  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <Grid>
        <Box
          sx={{
            p: 1,
            marginBottom: 2,
          }}
        >
          <NimbusLogo height="100px" width="170px" />
        </Box>
      </Grid>
      <Grid sx={{ textAlign: 'center' }}>
        <Typography
          variant="h5"
          color="primary"
          sx={{
            fontWeight: 'bold',
            fontSize: 20,
            ...unselectableStyles,
          }}
        >
          {getErrorTitle()}
        </Typography>
        <Typography>{getErrorMessage()}</Typography>
      </Grid>
      <Grid
        sx={{
          mt: 5,
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 2,
          }}
        >
          <Button variant="outlined" onClick={handleGoToHome}>
            Home
          </Button>
          <Button variant="contained" color="primary" onClick={handleReload}>
            Reload
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ErrorBoundary;
